module.exports = __webpack_public_path__ + "img/check.732b5ae1.svg";